import _extends from 'babel-runtime/helpers/extends';
import _Promise from 'babel-runtime/core-js/promise';
import _typeof from 'babel-runtime/helpers/typeof';

var isPromise = function isPromise(promise) {
  return (typeof promise === 'undefined' ? 'undefined' : _typeof(promise)) === 'object' && typeof promise.then === 'function';
};

function trackedPromisesEnhancer() {
  var promises = [];
  var registerPromise = function registerPromise(promise) {
    var clear = function clear() {
      var i = promises.indexOf(promise);

      if (i >= 0) {
        promises.splice(i, 1);
      }
    };

    promises.push(promise);
    promise.then(clear, clear);

    return promise;
  };
  var waitForPromises = function waitForPromises() {
    return promises.length ? _Promise.all(promises) : _Promise.resolve();
  };
  var onPromisesComplete = function onPromisesComplete(cb, errCb) {
    return waitForPromises().then(cb, errCb);
  };
  var hasPromisesRemaining = function hasPromisesRemaining() {
    return promises.length > 0;
  };

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var dispatch = function dispatch(action) {
        return (typeof action === 'undefined' ? 'undefined' : _typeof(action)) === 'object' && action.payload && isPromise(action.payload) ? registerPromise(action.payload).then(function (payload) {
          return store.dispatch(_extends({}, action, { payload: payload }));
        }, function (payload) {
          store.dispatch(_extends({}, action, { payload: payload, error: true }));

          if (process.env.NODE_ENV !== "production") {
            console.error('Action "' + action.type + '" error: ', payload);
          }
        }) : isPromise(action) ? registerPromise(action).then(store.dispatch) : store.dispatch(action);
      };

      return _extends({}, store, {
        dispatch: dispatch,
        hasPromisesRemaining: hasPromisesRemaining,
        onPromisesComplete: onPromisesComplete,
        waitForPromises: waitForPromises
      });
    };
  };
}

export default trackedPromisesEnhancer;
